import {useState, useEffect} from 'react';

import AddOrderStory from 'story/AddOrderStory';
export default function AddorderActionImpl(){

    return (
        <>
       <AddOrderStory />
        </>
    )
}